import React from "react"
import styles from "./Header.module.scss"

type Props = {
    title: string;
    close: () => void;
}

export const HeaderComponent: React.FC<Props> = ({title, close}) => {
    return (
        <header className={styles.header}>
            <span className={styles.title}>
                {title}
            </span>
            <button
                type="button"
                className={styles.close}
                aria-label="Close"
                onClick={close}
            >
                ×
            </button>
        </header>
    )
}